import { InputNumber } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { requiredInputNumberRules } from '../../../../../../../../../../constants/forms/validation/rules'

interface QuantityProps {}

const Quantity: FC<QuantityProps> = () => {
    const name = 'quantity'

    return (
        <Form.Item name={name} label={'Количество'} rules={requiredInputNumberRules}>
            <InputNumber />
        </Form.Item>
    )
}

export default Quantity
